import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
var Popover = function (_a) {
    var header = _a.header, children = _a.children, id = _a.id, isOpen = _a.isOpen, toggle = _a.toggle;
    var popoverRef = useRef(null);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (popoverRef.current && !popoverRef.current.contains(event.target))
                toggle();
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);
    if (!isOpen)
        return null;
    return (_jsx("div", { ref: popoverRef, children: _jsxs("div", { "data-popover": true, id: id, role: "tooltip", className: "inline-block w-64 bg-white border border-gray-200 rounded-lg shadow-xs", children: [header ? (_jsx("div", { className: "px-3 py-2 bg-gray border-b border-gray rounded-t-lg", children: _jsx("h3", { className: "font-semibold text-gray-900 dark:text-white", children: header }) })) : null, _jsx("div", { className: "px-3 py-2", children: children }), _jsx("div", { "data-popper-arrow": true })] }) }));
};
export default Popover;
